/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const SdfxBox = /*@__PURE__*/ createReactComponent('sdfx-box');
export const SdfxBoxStack = /*@__PURE__*/ createReactComponent('sdfx-box-stack');
export const SdfxCarousel = /*@__PURE__*/ createReactComponent('sdfx-carousel');
export const SdfxCarouselItem = /*@__PURE__*/ createReactComponent('sdfx-carousel-item');
export const SdfxConfetti = /*@__PURE__*/ createReactComponent('sdfx-confetti');
export const SdfxHelp = /*@__PURE__*/ createReactComponent('sdfx-help');
export const SdfxHelpDialog = /*@__PURE__*/ createReactComponent('sdfx-help-dialog');
export const SdfxInlineModal = /*@__PURE__*/ createReactComponent('sdfx-inline-modal');
export const SdfxListbox = /*@__PURE__*/ createReactComponent('sdfx-listbox');
export const SdfxMdfButtonCardStack = /*@__PURE__*/ createReactComponent('sdfx-mdf-button-card-stack');
export const SdfxMdfButtonStack = /*@__PURE__*/ createReactComponent('sdfx-mdf-button-stack');
export const SdfxMdfCheckbox = /*@__PURE__*/ createReactComponent('sdfx-mdf-checkbox');
export const SdfxMdfCheckboxGroup = /*@__PURE__*/ createReactComponent('sdfx-mdf-checkbox-group');
export const SdfxMdfForm = /*@__PURE__*/ createReactComponent('sdfx-mdf-form');
export const SdfxMdfInput = /*@__PURE__*/ createReactComponent('sdfx-mdf-input');
export const SdfxMdfLayoutColumns = /*@__PURE__*/ createReactComponent('sdfx-mdf-layout-columns');
export const SdfxMdfLayoutMasonry = /*@__PURE__*/ createReactComponent('sdfx-mdf-layout-masonry');
export const SdfxMdfLayoutMetaDriven = /*@__PURE__*/ createReactComponent('sdfx-mdf-layout-meta-driven');
export const SdfxMdfLayoutVertical = /*@__PURE__*/ createReactComponent('sdfx-mdf-layout-vertical');
export const SdfxMdfRadioGroup = /*@__PURE__*/ createReactComponent('sdfx-mdf-radio-group');
export const SdfxMdfReadonly = /*@__PURE__*/ createReactComponent('sdfx-mdf-readonly');
export const SdfxMdfSegmented = /*@__PURE__*/ createReactComponent('sdfx-mdf-segmented');
export const SdfxMdfSelect = /*@__PURE__*/ createReactComponent('sdfx-mdf-select');
export const SdfxMdfSurvey = /*@__PURE__*/ createReactComponent('sdfx-mdf-survey');
export const SdfxMdfText = /*@__PURE__*/ createReactComponent('sdfx-mdf-text');
export const SdfxMdfTextarea = /*@__PURE__*/ createReactComponent('sdfx-mdf-textarea');
export const SdfxPagination = /*@__PURE__*/ createReactComponent('sdfx-pagination');
export const SdfxSearch = /*@__PURE__*/ createReactComponent('sdfx-search');
export const SdfxWizardLayout = /*@__PURE__*/ createReactComponent('sdfx-wizard-layout');
export const SdfxWizardStepsVertical = /*@__PURE__*/ createReactComponent('sdfx-wizard-steps-vertical');
export const SdfxWizardStepsVerticalItem = /*@__PURE__*/ createReactComponent('sdfx-wizard-steps-vertical-item');
//# sourceMappingURL=sdfx-components.js.map